import moment from 'moment';
class StorageCrud {

  storeWarenkorbKey(id, isLoggedIn) {
    localStorage.setItem(
      "warenkorbKey",
      JSON.stringify({
        createdAt: this.addMinutes(Date.now(), 60),
        isLoggedIn: isLoggedIn,
        value: id,
      })
    );
  }

  /**
   * Gets the warenkorb key of the localStorage, if it returns null it is because it does not exist or because it has expired
   * @returns
   */
  getWarenkorbObj() {
    const obj = JSON.parse(localStorage.getItem("warenkorbKey"));
    if (!obj) {
      return null;
    }

    const isValid = this.compareDate(obj.createdAt);
    if (!isValid) {
      this.removeWarenkorbKey();
      return null;
    }

    return obj;
  }

  /**
   * Gets the warenkorb key of the localStorage, if it returns null it is because it does not exist or because it has expired
   * @returns
   */
  getWarenkorbKey() {
    const obj = JSON.parse(localStorage.getItem("warenkorbKey"));
    if (!obj) {
      return null;
    }
    if (!obj.value) {
      return null;
    }

    const isValid = this.compareDate(obj.createdAt);
    if (!isValid) {
      this.removeWarenkorbKey();
      return null;
    }

    return obj.value;
  }
  /**
   * Remove warenkorb key
   */
  removeWarenkorbKey() {
    localStorage.removeItem("warenkorbKey");
  }


  storeGuestMerklisteKey(key) {
    localStorage.setItem(
      "guestMerklisteKey",
      JSON.stringify({
        createdAt: this.addMinutes(Date.now(), 60),
        value: key,
      })
    );
  }

  removeGuestMerklisteKey() {
    localStorage.removeItem("guestMerklisteKey");
  }

  getGuestMerklisteKey() {
    const obj = JSON.parse(localStorage.getItem("guestMerklisteKey"));
    if (!obj || !obj.value) {
      return null;
    }

    const isValid = this.compareDate(obj.createdAt);
    if (!isValid) {
      this.removeGuestMerklisteKey();
      return null;
    }

    return obj.value;
  }

  setBookingData(key, step, highestCompletedStep) {
    localStorage.setItem("checkoutData", JSON.stringify({
      bookingKey: key,
      step: step,
      highestCompletedStep: highestCompletedStep,
      createdAt: new Date().getTime(),
    }));
  }
  getBookingData() {
    return JSON.parse(localStorage.getItem("checkoutData"));
  }
  removeBookingData() {
    localStorage.removeItem("checkoutData");
  }

  addMinutes(date, minutes) {
    return new Date(date + minutes * 60000);
  }

  compareDate(data) {
    return new Date(Date.now()) < new Date(data);
  }

  setBundleData(bundleId, bundleConfiguration) {
    const storageData = JSON.parse(localStorage.getItem("bundleData") || "{}");
    storageData[bundleId] = bundleConfiguration;
    localStorage.setItem("bundleData", JSON.stringify(storageData));
  }

  deleteBundleData(bundleId) {
    const storageData = JSON.parse(localStorage.getItem("bundleData") || "{}");
    if(storageData[bundleId]) {
      delete storageData[bundleId];
      localStorage.setItem("bundleData", JSON.stringify(storageData));
    }
  }

  getBundleData(bundleId) {
    const storageData = JSON.parse(localStorage.getItem("bundleData") || "{}");
    const bundle = storageData[bundleId] ?? null;
    if(bundle) {
      const time24HoursAgo = moment().subtract(1, 'days').unix();
      if(bundle.createTime && time24HoursAgo > moment(bundle.createTime).unix()) {
        console.log('remove expired bundle configuration from localstorage');
        this.deleteBundleData(bundleId);
      } else {
        return bundle;
      }
    }
    return null;
  }
}

export default StorageCrud;
